import React from 'react';
import { AIOperationsWorkspace } from './AIOperationsWorkspace';

export default function App() {
  const config = window.__AI_OPERATIONS_WORKSPACE__ ?? {};

  return (
    <AIOperationsWorkspace
      accessToken={config.accessToken}
      apiBaseUrl={config.apiBaseUrl ?? ''}
    />
  );
}
